<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1BNbB2w/images/EveOfWarfare_cover.jpg?1684515199462" alt="This image is the cover for the book Eve of Warfare, Marked"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Eve of Warfare, Marked
      </h1>
      <p class="bookDescription body article font2">
        <p>Lycans, vampires, and cherubs... oh my. All Evangeline Hollis wants is to stay out of trouble long enough to lose the Mark of Cain, which drafted her into hunting demons for God. A former agnostic, she’s still recovering from being the latest point of contention between the two men in her life--Cain and Abel. Now she’s working for a cherub who thinks putting her undercover as a housewife is the best way to ferret out a rogue vampire hiding in an idyllic Orange County, California residential community. Eve knows when she’s being used as a pawn in the celestial political game. Now, she just has to figure out who’s the greater threat: the vampire she’s hunting, the cherub yanking her chain, or the two brothers vying to play the role of her spouse--‘til death do them part. Which in her line of work, could happen any minute... ("Eve of Warfare" is a stand-alone novella, which falls after EVE OF CHAOS in the Marked series chronology.) Includes bonus content: the opening chapter of EVE OF DARKNESS</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sylvia Day, S.J. Day
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Sylvia Day
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?59460a62